import { HStack, Text, VStack } from '@chakra-ui/react'
import { MouseEvent } from 'react'
import { GrandNextLink } from 'ui'
import { useRouter } from 'next/navigation'

import { useSelector } from 'shared-redux'
import { commaSeparator } from 'shared-utils'
import { selectedCart } from 'shared-redux/state'

function CartSlideOutFooter() {
  const { cartTotal, cartItems } = useSelector(selectedCart)
  const router = useRouter()

  const handleCheckout = async (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    router.push('/checkout')
  }

  return (
    <VStack
      pb={4}
      spacing={{
        base: 4,
        md: 2
      }}
      w="100%">
      <HStack fontSize="md" fontWeight="bold" justify="space-between" w="100%">
        <Text>Totalt</Text>
        <Text>{`${commaSeparator(cartTotal)} SEK`}</Text>
      </HStack>
      <GrandNextLink
        alignSelf="center"
        aria-label="kundvagn"
        bg="primary"
        href="/checkout"
        isButton
        isDisabled={!cartItems.length}
        onClick={handleCheckout}
        w={{
          base: '100%',
          sm: '50%'
        }}>
        Kundvagn
      </GrandNextLink>
    </VStack>
  )
}

export default CartSlideOutFooter
